
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol id=\"triangle-down-icon_jax_8fbd994b63954b79ed6cabb0ae69ac4f\" ><path d=\"M13.14 15.298a.5.5 0 0 1-.854 0L8.918 9.76A.5.5 0 0 1 9.345 9h6.737a.5.5 0 0 1 .427.76l-3.368 5.538z\" fill=\"#2A2A2A\"/></symbol>";
module.exports = sprite.add(image, "triangle-down-icon_jax_8fbd994b63954b79ed6cabb0ae69ac4f");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/triangle-down-icon.svg
// module id = 304
// module chunks = 1